export default "__VITE_ASSET__CXlUzJI9__"